var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", [
        _c("h1", [_vm._v("EXAMPLE 1")]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { name: "form1" },
            on: {
              click: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form1.select,
                    expression: "form1.select"
                  }
                ],
                attrs: { name: "select" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form1,
                      "select",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v("Please select one")
                ]),
                _vm._v(" "),
                _c("option"),
                _vm._v(" "),
                _c("option", [_vm._v("A")]),
                _vm._v(" "),
                _c("option", [_vm._v("B")]),
                _vm._v(" "),
                _c("option", [_vm._v("C")])
              ]
            ),
            _vm._v(" "),
            _vm.$hasError("select")
              ? _c("span", [_vm._v(_vm._s(_vm.$hasError("select")))])
              : _vm._e(),
            _vm._v(" "),
            _c("c-input", {
              directives: [
                {
                  name: "validator",
                  rawName: "v-validator",
                  value: { required: true },
                  expression: "{ required: true }"
                }
              ],
              attrs: {
                label: "Razão social",
                name: "name",
                validation: _vm.$hasError("name")
              },
              model: {
                value: _vm.form1.name,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "name", $$v)
                },
                expression: "form1.name"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              directives: [
                {
                  name: "validator",
                  rawName: "v-validator",
                  value: {
                    required: true,
                    pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i
                  },
                  expression:
                    "{ required: true, pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\\.[A-Z0-9-]+)+$/i }"
                }
              ],
              attrs: {
                label: "E-mail",
                name: "email",
                validation: _vm.$hasError("email")
              },
              model: {
                value: _vm.form1.email,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "email", $$v)
                },
                expression: "form1.email"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Cnpj",
                name: "registry_code",
                validation: _vm.$hasError("registry_code")
              },
              model: {
                value: _vm.form1.registry_code,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "registry_code", $$v)
                },
                expression: "form1.registry_code"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Telefone",
                name: "phone",
                validation: _vm.$hasError("phone")
              },
              model: {
                value: _vm.form1.phone,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "phone", $$v)
                },
                expression: "form1.phone"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Cep",
                name: "zipcode",
                validation: _vm.$hasError("zipcode", "form1")
              },
              model: {
                value: _vm.form1.zipcode,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "zipcode", $$v)
                },
                expression: "form1.zipcode"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Número",
                name: "number",
                validation: _vm.$hasError("number", "form1")
              },
              model: {
                value: _vm.form1.number,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "number", $$v)
                },
                expression: "form1.number"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: { label: "Complemento", name: "additional_details" },
              model: {
                value: _vm.form1.additional_details,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "additional_details", $$v)
                },
                expression: "form1.additional_details"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Bairro",
                name: "neighborhood",
                validation: _vm.$hasError("neighborhood", "form1")
              },
              model: {
                value: _vm.form1.neighborhood,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "neighborhood", $$v)
                },
                expression: "form1.neighborhood"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Cidade",
                name: "city",
                validation: _vm.$hasError("city", "form1")
              },
              model: {
                value: _vm.form1.city,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "city", $$v)
                },
                expression: "form1.city"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: {
                label: "Estado",
                name: "state",
                validation: _vm.$hasError("state", "form1")
              },
              model: {
                value: _vm.form1.state,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "state", $$v)
                },
                expression: "form1.state"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              attrs: { label: "Observações", name: "description" },
              model: {
                value: _vm.form1.description,
                callback: function($$v) {
                  _vm.$set(_vm.form1, "description", $$v)
                },
                expression: "form1.description"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$validator.touch("name2", "form2")
                  }
                }
              },
              [_vm._v("Touch Field")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$validator.validateField("name")
                  }
                }
              },
              [_vm._v("Validate NAME Field")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$validator.validateForm("form1")
                  }
                }
              },
              [_vm._v("Validate FORM1 Form")]
            ),
            _vm._v(" "),
            _c("button", { on: { click: _vm.removeField } }, [
              _vm._v("Remove Field")
            ]),
            _vm._v(" "),
            _c("button", { on: { click: _vm.addField } }, [
              _vm._v("Add Field")
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$validator.resetField("name")
                  }
                }
              },
              [_vm._v("Reset NAME Field")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.$validator.resetForm("form1")
                  }
                }
              },
              [_vm._v("Reset FORM1 Form")]
            ),
            _vm._v(" "),
            _c("button", { on: { click: _vm.submit } }, [_vm._v("Salvar")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { name: "form2" },
            on: {
              click: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("c-input", {
              directives: [
                {
                  name: "validator",
                  rawName: "v-validator",
                  value: { required: true },
                  expression: "{ required: true }"
                }
              ],
              attrs: {
                label: "Razão social",
                name: "name2",
                validation: _vm.$hasError("name2", "form2")
              },
              model: {
                value: _vm.form2.name2,
                callback: function($$v) {
                  _vm.$set(_vm.form2, "name2", $$v)
                },
                expression: "form2.name2"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              directives: [
                {
                  name: "validator",
                  rawName: "v-validator",
                  value: {
                    required: true,
                    pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i
                  },
                  expression:
                    "{ required: true, pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\\.[A-Z0-9-]+)+$/i }"
                }
              ],
              attrs: {
                label: "E-mail",
                name: "email2",
                validation: _vm.$hasError("email2", "form2")
              },
              model: {
                value: _vm.form2.email2,
                callback: function($$v) {
                  _vm.$set(_vm.form2, "email2", $$v)
                },
                expression: "form2.email2"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [_vm._v("OPEN FORM BOLADAO")]
      ),
      _vm._v(" "),
      _c(
        "c-modal",
        {
          attrs: { "is-open": _vm.isOpen },
          on: {
            close: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _c(
            "form",
            {
              attrs: { name: "form3" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("c-input", {
                directives: [
                  {
                    name: "validator",
                    rawName: "v-validator",
                    value: { required: true },
                    expression: "{ required: true }"
                  }
                ],
                attrs: {
                  label: "Razão social",
                  name: "name3",
                  validation: _vm.$hasError("name3", "form3")
                },
                model: {
                  value: _vm.form3.name3,
                  callback: function($$v) {
                    _vm.$set(_vm.form3, "name3", $$v)
                  },
                  expression: "form3.name3"
                }
              }),
              _vm._v(" "),
              _c("c-input", {
                directives: [
                  {
                    name: "validator",
                    rawName: "v-validator",
                    value: {
                      required: true,
                      pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i
                    },
                    expression:
                      "{ required: true, pattern: /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\\.[A-Z0-9-]+)+$/i }"
                  }
                ],
                attrs: {
                  label: "E-mail",
                  name: "email3",
                  validation: _vm.$hasError("email3", "form3")
                },
                model: {
                  value: _vm.form3.email3,
                  callback: function($$v) {
                    _vm.$set(_vm.form3, "email3", $$v)
                  },
                  expression: "form3.email3"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }